<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="16">
                <el-button v-if="$isSuperAdmin" type="primary" icon="el-icon-plus" @click="dialogVisible = true">{{$t('common.create')}}</el-button>
            </el-col>

            <el-col :span="4">
                <el-input v-model="filter.email"
                          :placeholder="$t('common.email')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
            <el-col :span="4">
                <el-input v-model="filter.userName"
                          :placeholder="$t('masters.userName')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="users" v-loading="loading" class="orders-table tablewithshading" @sort-change="sortServiceTickets">
            <el-table-column prop="userName" :label="$t('masters.userName')" width="150" sortable="custom"></el-table-column>
            <el-table-column prop="email" :label="$t('common.email')" sortable="custom"></el-table-column>
            <el-table-column prop="phoneNumber" :label="$t('common.phone')"></el-table-column>
            <el-table-column :label="$t('masters.isReadOnly')">
                <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.isReadOnly"></i>
                </template>
            </el-table-column>
            <el-table-column v-if="$isSuperAdmin" :label="$t('masters.isSuperAdmin')">
                <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.isSuperAdmin"></i>
                </template>
            </el-table-column>
            <el-table-column v-if="$isSuperAdmin" :label="$t('common.operations')" fixed="right" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editUser(scope.row.id)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button size="mini" type="danger" @click="deleteUser(scope.row.id)">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <create-update-user-dialog :userId="userToEdit" :visible="dialogVisible" @dialogClosed="editFinished" @save="appendUser"></create-update-user-dialog>
    </div>
</template>

<script>
    import CreateUpdateUserDialog from './CreateUpdateUserDialog'
    import api from '../api'
    export default {
        name: 'user-list',
        components: {
            CreateUpdateUserDialog
        },
        data() {
            return {
                users: [],
                loading: true,
                dialogVisible: false,
                userToEdit: null,
                filter: {
                    email: '',
                    userName: ''
                },
                currentPage: 1,
                total: 0,
                sorting: {}
            }
        },
        created() {
            this.loadUsers();        
        },
        watch: {
            filter: {
                deep: true,
                handler: function (val) {
                    this.loadUsers();
                }
            }
        },
        methods: {
            loadUsers() {
                this.loading = true                
                api.getUsers(this.currentPage, this.filter, this.sorting).then(response => {
                    this.loading = false
                    this.users = response.data.items
                    this.total = response.data.total
                })
            },
            appendUser(event) {
                if (event.new) {
                    this.users.push(event.data);
                    this.total += 1;
                } else {
                    this.loadUsers();
                }
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadUsers();
            },
            editUser(id) {
                this.userToEdit = id
                this.dialogVisible = true
            },
            editFinished() {
                this.userToEdit = null
                this.dialogVisible = false
            },
            deleteUser(id) {
                this.$confirm(this.$t('common.thisWillDeleteUserContinue'), 'Warning', {
                    confirmButtonText: this.$t('common.delete'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: 'warning'
                }).then(() => {
                    api.deleteUser(id).then((r) => {
                        this.loadUsers();
                        this.$message({
                            type: 'success',
                            message: this.$t('common.deleteCompleted')
                        })
                    })
                        .catch((err) => {
                            this.$message({
                                type: 'error',
                                message: err.response.data
                            })

                        });
                }).catch(_ => {});
            },
            sortServiceTickets(sort) {
                let sortBy = sort.prop;
                if (!sortBy && sort.column != null) {
                    sortBy = sort.column.label;
                }
                let sortOrder = sort.order;
                this.sorting = {
                    sortBy,
                    sortOrder
                };
                if (this.currentPage === 1) {
                    this.loadUsers();
                } else {
                    this.currentPage = 1;
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// ClientApp/app/masters/users/components/UserList.vue